export { authApi } from './auth';
export { employeeApi } from './employees';
export { projectApi } from './projects';
export { allocationApi } from './allocations';
export { importApi } from './import';
export { importU8Api } from './importU8';
export { default as apiClient } from './client';

import apiClient from './client';

export const databaseApi = {
  clear: async (): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>('/database/clear');
    return response.data;
  },
};
